import {API_ROOT} from '../../baseUrls';

export const GET_MINDFILE_FILTERS = 'GET_MINDFILE_FILTERS';

export function getFilterValues(mid, updated=0, callback = () => {}) {
  return function(dispatch, getState) {
    let url = new URL(`${ API_ROOT }/mindfiles/${ mid }/filters/list?updated=${updated.toString()}`)
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then(data => {
      if(data.ok){
        //nothing to do
      }else {
        dispatch({
          type: GET_MINDFILE_FILTERS,
          payload: data,
        })
      }
    })
    .catch(err => console.error(err))
    .finally(() => callback());
  }
}

export function mindfileFilterValues(state = [], action) {
  switch (action.type) {
    case GET_MINDFILE_FILTERS:
      return  action.payload || state;
    default:
      return  state;
  }
}
